<template>
  <v-card>

    <v-card-title>
      <h4>Vault Information</h4>
      <v-spacer></v-spacer>
      <v-btn v-if="!isLoading" class="" icon @click="loadVaultSummary">
        <v-icon>mdi-cached</v-icon>
      </v-btn>
      <v-overlay :value="isLoading" absolute>
      <v-progress-circular v-if="isLoading" :size="36" color="primary" indeterminate></v-progress-circular>
      </v-overlay>
    </v-card-title>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>Pending:</v-list-item-content>
        <v-list-item-content
          class="align-end"
        >${{ summary == null ? '0.00' : summary.pending.toFixed(2) }}</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>To Trust:</v-list-item-content>
        <v-list-item-content
          class="align-end"
        >${{ summary == null ? '0.00' : summary['in-transit-to-trust'].toFixed(2) }}</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Received:</v-list-item-content>
        <v-list-item-content
          class="align-end"
        >${{ summary == null ? '0.00' : summary.received.toFixed(2) }}</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>To Client:</v-list-item-content>
        <v-list-item-content
          class="align-end"
        >${{ summary == null ? '0.00' : summary['in-transit-to-client'].toFixed(2) }}</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Cashed Out:</v-list-item-content>
        <v-list-item-content
          class="align-end"
        >${{ summary == null ? '0.00' : summary['cashed-out'].toFixed(2) }}</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Deleted:</v-list-item-content>
        <v-list-item-content
          class="align-end"
        >${{ summary == null ? '0.00' : summary.deleted.toFixed(2) }}</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Error:</v-list-item-content>
        <v-list-item-content
          class="align-end"
        >${{ summary == null ? '0.00' : summary.error.toFixed(2) }}</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    summary: null,
    isLoading: false
  }),
  created () {
    this.loadVaultSummary()
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadVaultSummary()
      }
    }
  },
  methods: {
    async loadVaultSummary () {
      if (this.user == null || this.user.userId == null || this.user.userId === '') {
        this.summary = null
        return
      }
      this.isLoading = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ACCOUNT}/total-amounts/${this.user.userId}`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.isLoading = false
        this.errors.push(e)
      })
      if (getResponse === undefined || getResponse.data === '') {
        this.summary = null
      } else {
        this.summary = getResponse.data
      }
      this.isLoading = false
    }
  }
}
</script>
<style>
</style>
